<script setup lang="ts"></script>
<template>
  <div
    class="bg-btnPlusBg shadow-custom absolute top-1 right-1 z-200 flex size-7 flex-row content-center items-center justify-center rounded-[10px]"
  >
    <div class="flex items-center justify-center p-0">
      <svg
        width="34"
        height="35"
        viewBox="0 0 34 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_ddi_7045_3261)">
          <rect
            x="3"
            y="1"
            width="28"
            height="28"
            rx="10"
            fill="url(#paint0_linear_7045_3261)"
          />
          <path
            d="M11 15H23"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M17 21V9"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <filter
            id="filter0_ddi_7045_3261"
            x="0"
            y="0"
            width="34"
            height="35"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feMorphology
              radius="1"
              operator="erode"
              in="SourceAlpha"
              result="effect1_dropShadow_7045_3261"
            />
            <feOffset dy="3" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 1 0 0 0 0 0.682353 0 0 0 0 0.207843 0 0 0 0.95 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_7045_3261"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feMorphology
              radius="1"
              operator="dilate"
              in="SourceAlpha"
              result="effect2_dropShadow_7045_3261"
            />
            <feOffset />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.964706 0 0 0 0 0.517647 0 0 0 0 0.00784314 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="effect1_dropShadow_7045_3261"
              result="effect2_dropShadow_7045_3261"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect2_dropShadow_7045_3261"
              result="shape"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="1" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
            />
            <feBlend
              mode="normal"
              in2="shape"
              result="effect3_innerShadow_7045_3261"
            />
          </filter>
          <linearGradient
            id="paint0_linear_7045_3261"
            x1="3"
            y1="1"
            x2="32.494"
            y2="1.91916"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FBAF01" />
            <stop offset="1" stop-color="#F89303" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  </div>
</template>
